import { Restriction } from 'components/voucher/voucher-create/restriction/Restriction'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_VOUCHER } from 'services/apiVoucher'
import { constructOptionMultipleSelect, constructOptionsSelect } from 'utils/utils'

export const RestrictionContainer = ({ sectionRef, voucherDetail, onChangeForm, errorForm }) => {
    const { fetching: getProductList } = useFetch(API_VOUCHER.PRODUCT_LIST)
    const { fetching: getCategoryList } = useFetch(API_VOUCHER.CATEGORY_LIST)
    const { fetching: getBrandList } = useFetch(API_VOUCHER.BRAND_LIST)
    const { fetching: getShippingMethods } = useFetch(API_VOUCHER.SHIPPING_METHODS)
    const { fetching: getPaymentMethods } = useFetch(API_VOUCHER.PAYMENT_METHODS)
    const { fetching: getAllowedEmail } = useFetch(API_VOUCHER.ALLOWED_EMAIL)
    const [options, setOptions] = useState({
        include_product: [],
        exclude_product: [],
        include_category: [],
        exclude_category: [],
        include_brand: [],
        exclude_brand: [],
        shipping_courier: [],
        payment_method: [],
        allowed_email: [],
    })

    const onFilterOptions = (options, key) => {
        const includeExcludeIds = voucherDetail?.restriction?.[key]?.map((item) => item?.value)
        return options?.filter((item) => !includeExcludeIds?.includes(item?.value))
    }

    const onChangeRestriction = (item) => {
        const newItem = { ...voucherDetail?.restriction, ...item }
        onChangeForm({ restriction: newItem })
    }

    const getAPIOption = (type, payload) => {
        switch (type) {
            case 'include_product':
            case 'exclude_product':
                return getProductList(payload)
            case 'include_category':
            case 'exclude_category':
                return getCategoryList(payload)
            case 'include_brand':
            case 'exclude_brand':
                return getBrandList(payload)
            case 'allowed_email':
                return getAllowedEmail(payload)
            default:
                return
        }
    }

    const onSearchOptions = (type, value) => {
        getAPIOption(type, { search: value }).then((response) => {
            let newList
            if (type === 'include_product' || type === 'exclude_product') {
                newList = constructOptionMultipleSelect(response?.data, 'name', 'id', 'image_url')
            } else {
                const isEmail = type === 'allowed_email'
                newList = constructOptionsSelect(response?.data, isEmail ? 'email' : 'name', isEmail ? 'email' : 'id')
            }
            setOptions({ ...options, [type]: newList })
        })
    }

    useEffect(() => {
        Promise.all([
            getCategoryList(),
            getBrandList(),
            getShippingMethods(),
            getPaymentMethods({ withoutGrouping: true }),
        ]).then((result) => {
            const newOptions = {
                include_category: constructOptionsSelect(result[0]?.data, 'name', 'id'),
                exclude_category: constructOptionsSelect(result[0]?.data, 'name', 'id'),
                include_brand: constructOptionsSelect(result[1]?.data, 'name', 'id'),
                exclude_brand: constructOptionsSelect(result[1]?.data, 'name', 'id'),
                shipping_courier: result[2]?.data,
                payment_method: result[3]?.data,
            }
            setOptions({ ...options, ...newOptions })
        })
    }, [])

    const props = {
        sectionRef: sectionRef?.restriction,
        voucherDetail: voucherDetail?.restriction,
        onFilterOptions,
        onChangeRestriction,
        options,
        onSearchOptions,
        errorForm,
    }

    return <Restriction {...props} />
}
